import { render, staticRenderFns } from "./CargoCheck.vue?vue&type=template&id=43c51d88&scoped=true&"
import script from "./CargoCheck.vue?vue&type=script&lang=js&"
export * from "./CargoCheck.vue?vue&type=script&lang=js&"
import style0 from "./CargoCheck.vue?vue&type=style&index=0&id=43c51d88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c51d88",
  null
  
)

export default component.exports